import { InterceptorDisplayType } from "@ftr/owa-core";
import { scanBot } from "./environment.scanbot";

export const environment = {
    production: true,
    authConfig: {
        issuer: 'https://login.microsoftonline.com/5fe198e9-aa7c-45d2-9da7-4fbbeb5d542e/v2.0',
        redirectUri: window.location.origin,
        oidc: true,
        clientId: '3a8f6dae-7450-4c4f-88fe-a57b6d4ab18b',
        scope: 'openid api://mtpn.ftr.com/access-mtpn offline_access',
        responseType: 'code',
        strictDiscoveryDocumentValidation: false,
        showDebugInformation: true
    },
    timeKeepingConfiguration: {
        allowTimeCardEdit: true
    },
    coreConfiguration: {
        appId: "MTP",
        cacheAge: 8,
        baseUrl: 'https://api-prod.frontier.com',
        openshiftOverwriteUrl: '$OPENSHIFT_URL_REPLACEMENT',
        allowShadowing: true,
        enableOffline: true,
        serviceInterval: 30000,
        allowInterceptorDebugging: false,
        pendingQueueRoute: '/pendingqueue',
        allowForgery: false,
        errorHandlingConfig: {
            duration: 3000,
            defaultSuccessHandling: InterceptorDisplayType.None,
            defaultErrorHandling: InterceptorDisplayType.SnackBar
        },
        notificationConfig: {
            timeout: 10000,
            interval: 30000,
            retry: 120,
            turnOffNotifications: false,
            turnOffFirebaseNotifications: false,
            turnOffSoundForNotifications: false
        },
        getCallsRetryIntervalSeconds: 3000,
        getCallsMaxRetryCount: 3,
        primaryDeviceCheck: true,
        openShiftReplacements: {
            owatimekeeping: "tksapi",
            owatechs: "tecapi",
            owanotification: "ntfapi",
            owalogging: "logapi",
            owajobs: "jobapi",
            owafacilities: "tksapi",
            owaDynamicForms: "dyfapi",
            owadiagnostics: "dgnapi",
            owaconfiguration: "cfgapi",
            owatasks: "tskapi",
        },
        firebaseConfig:{
            apiKey: 'REPLACE_FIREBASE_API_KEY',
            authDomain: "mtp-test-96a56.firebaseapp.com",
            projectId: "mtp-test-96a56",
            storageBucket: "mtp-test-96a56.appspot.com",
            messagingSenderId: "285058400319",
            appId: "1:285058400319:web:55dd14a08bf0d4d6aa788a",
            measurementId: "G-9VHW67HTL5"
        }
    },
    jobConfiguration: {
        requestWorkButtonTimeOut: 360000,
        dpiEnv: "CP1",
        turnOnLockoutUntilVxfieldUpdates: true,
        lockoutTime: 90,
        turnOffSparkAppLaunch: false
    },
    externalURLConfiguration: {
        patsUrl: "https://mpats.ftr.com",
        urhUrl: "https://urh.ftr.com/"
    },
    swcForm: {
        enabled: true
    },
    userConfiguration:{
    canSeeSelf:false,
  },
  scanBotLicense:scanBot.licenseKey
};
